interface HeroProps {
  onBookClick: () => void;
}

export default function Hero({ onBookClick }: HeroProps) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-radial from-red-900/40 via-black to-black"></div>
      
      {/* Animated particles */}
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-red-500/30 rounded-full animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 3}s`
            }}
          />
        ))}
      </div>

      {/* Background image */}
      <div className="absolute inset-0 flex items-end justify-center opacity-20">
        <div className="w-full h-3/4 bg-gradient-to-t from-black via-transparent to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="text-7xl md:text-8xl font-black text-white mb-6" style={{ 
          fontFamily: 'Playfair Display, serif',
          textShadow: '0 0 40px rgba(220, 20, 60, 0.5), 0 0 80px rgba(220, 20, 60, 0.3)'
        }}>
          THOMAS IS FRENCH
        </h1>
        
        <p className="text-xl md:text-2xl text-gray-300 mb-4" style={{ 
          fontFamily: 'Playfair Display, serif',
          letterSpacing: '0.2em'
        }}>
          Comedian • Mentalist • Magician
        </p>
        
        <p className="text-lg md:text-xl text-red-400 italic mb-12" style={{ fontFamily: 'Playfair Display, serif' }}>
          Where Mystery Meets Comedy
        </p>

        <button 
          onClick={onBookClick}
          className="group px-10 py-4 bg-red-600 text-white text-lg font-semibold rounded-full hover:bg-red-700 transition-all duration-300 hover:shadow-2xl hover:shadow-red-600/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
        >
          Experience the Magic
          <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
        </button>
      </div>

      {/* Decorative elements - REMOVED */}
    </section>
  );
}
